import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ManifestoChapters from "@/components/ManifestoChapters";
import SignaturePrograms from "@/components/SignaturePrograms";
import TeamSection from "@/components/TeamSection";
import ImpactMetrics from "@/components/ImpactMetrics";
import EcosystemGrid from "@/components/EcosystemGrid";
import CallToAction from "@/components/CallToAction";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Hero />
            <EditorialMarquee />
            <ManifestoChapters />
            <SignaturePrograms />
            <ImpactMetrics />
            <TeamSection />
            <EcosystemGrid />
            <CallToAction />
        </div>
    );
}
